import React, { useState } from "react";

import useFaqs from "./useFaqs";
import FaqRow from "./components/FaqRow";
import { FaqsListSkeleton } from "./components/FaqsSkeletons";
import { FAQS_COPY, FAQS_EMPTY_STATES } from "./faqsCopy";

import "./styles.css";

const EmptyView = ({ state, onRetry }) => (
  <div className="fq-empty">
    <img src="/assets/icons/faqs.svg" alt="" aria-hidden="true" />

    <h2>{state.title}</h2>
    <p>{state.body}</p>

    {onRetry && (
      <div className="fq-empty-actions">
        <button type="button" className="fq-btn fq-btn-outline" onClick={onRetry}>
          {FAQS_COPY.retry}
        </button>
      </div>
    )}
  </div>
);

const FaqsRoute = () => {
  const faqs = useFaqs();
  const [expandedId, setExpandedId] = useState(null);

  const onToggle = (id) => {
    setExpandedId((current) => (current === id ? null : id));
  };

  return (
    <div className="fq-screen">
      <header className="fq-pagehead">
        <h1 className="fq-pagetitle">{FAQS_COPY.pageTitle}</h1>
      </header>

      <div className="fq-band">
        <div className="fq-section-header">
          <h2 className="fq-section-title">{FAQS_COPY.sectionTitle}</h2>
          <p className="fq-section-sub">{FAQS_COPY.subtitle}</p>
        </div>

        {faqs.isLoading ? (
          <FaqsListSkeleton rows={8} />
        ) : faqs.isError ? (
          <EmptyView state={FAQS_EMPTY_STATES.listError} onRetry={faqs.refetch} />
        ) : faqs.items.length ? (
          <ul className="fq-list">
            {faqs.items.map((faq) => (
              <FaqRow
                key={faq.id}
                faq={faq}
                open={expandedId === faq.id}
                onToggle={onToggle}
              />
            ))}
          </ul>
        ) : (
          <EmptyView state={FAQS_EMPTY_STATES.noFaqs} />
        )}
      </div>
    </div>
  );
};

export default FaqsRoute;
